module.exports = __webpack_public_path__ + "media/img/home/product/mobile/product4-20f7416ed12d84a9d2e6597ce53c683c.svg";